import { AddRuleButton } from '@carboncopyco/editor-ui';
import type { IFindAndReplaceRuleType } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useContext, useState } from 'react';
import { FindAndReplaceManagerContext } from './FindAndReplaceManagerContext';
import { FindAndReplaceRuleSelectionPopover } from './FindAndReplaceRuleSelectionPopover';

export interface AddFindAndReplaceButtonProps {
  onSelect: (ruleType: IFindAndReplaceRuleType) => void;
}
export const AddFindAndReplaceButton = ({
  onSelect,
}: AddFindAndReplaceButtonProps) => {
  const { rules } = useContext(FindAndReplaceManagerContext);
  const { editorRulesAndVarsLimit } = useFlags();

  const [popoverOpen, setPopoverOpen] = useState(false);

  const reachedLimit = rules.length >= editorRulesAndVarsLimit;

  return (
    <FindAndReplaceRuleSelectionPopover
      triggerElement={
        <AddRuleButton
          onClick={() => setPopoverOpen(true)}
          disabled={reachedLimit}
          tooltipMessage={
            reachedLimit &&
            `You reached the limit of ${editorRulesAndVarsLimit} rules`
          }
        />
      }
      onSelect={(ruleType) => {
        onSelect(ruleType);
        setPopoverOpen(false);
      }}
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
    />
  );
};
